import { RG_TECH_CLASS } from "@project-rouge/rg-core";
function createGenericSpaceInstance() {
  const genericSpaceInstance = {
    name: "Generic Space",
    source: "Generic",
    spaceClass: RG_TECH_CLASS.Amenity,
    attributes: {},
    conditions: {}
  };
  return genericSpaceInstance;
}
export {
  createGenericSpaceInstance
};
//# sourceMappingURL=index136.js.map
